import React from "react";
import {
  Typography,
  Box,
  Container,
  IconButton,
  Button,
} from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import HomeIcon from "@mui/icons-material/Home";

const Footer = () => {
  // Function to handle smooth scrolling
  const scrollToSection = (event, sectionId) => {
    event.preventDefault();
    const section = document.querySelector(sectionId);

    if (section) {
      // Scroll to the section smoothly
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // Function to scroll to top
  const scrollToTop = (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        bgcolor: "rgb(10, 10, 15)",
        backdropFilter: "blur(10px)",
        py: 4,
        borderTop: "1px solid rgba(255, 255, 255, 0.1)",
      }}
    >
      <Container maxWidth="lg">
        {/* Navigation Links */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            alignItems: "center",
            mb: 3,
            gap: { xs: 1, sm: 3 },
          }}
        >
          <Button
            onClick={scrollToTop}
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              "&:hover": { color: "#A78BFA" },
              fontSize: "0.9rem",
              textTransform: "none",
            }}
          >
            Home
          </Button>
          <Button
            onClick={(e) => scrollToSection(e, "#about")}
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              "&:hover": { color: "#A78BFA" },
              fontSize: "0.9rem",
              textTransform: "none",
            }}
          >
            About
          </Button>
          <Button
            onClick={(e) => scrollToSection(e, "#projects")}
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              "&:hover": { color: "#A78BFA" },
              fontSize: "0.9rem",
              textTransform: "none",
            }}
          >
            Projects
          </Button>
          <Button
            onClick={(e) => scrollToSection(e, "#contact")}
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              "&:hover": { color: "#A78BFA" },
              fontSize: "0.9rem",
              textTransform: "none",
            }}
          >
            Contact
          </Button>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "rgba(255, 255, 255,.6)", mb: { xs: 2, md: 0 } }}
          >
            © {new Date().getFullYear()} Abhi. All rights reserved.
          </Typography>

          <Box>
            <IconButton
              aria-label="github"
              component="a"
              href="https://github.com/abhi-ramtel"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "rgba(255, 255, 255, .6)",
                "&:hover": { color: "#A78BFA" },
              }}
            >
              <GitHubIcon />
            </IconButton>
            <IconButton
              aria-label="linkedin"
              component="a"
              href="https://www.linkedin.com/in/abhi-ramtel"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "rgba(255, 255, 255, .6)",
                "&:hover": { color: "#A78BFA" },
              }}
            >
              <LinkedInIcon />
            </IconButton>
            {/* <IconButton
              aria-label="twitter"
              component="a"
              href="https://twitter.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "rgba(255, 255, 255, .6)",
                "&:hover": { color: "#A78BFA" },
              }}
            >
              <TwitterIcon />
            </IconButton> */}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "rgba(255, 255, 255, .4)", fontSize: "0.75rem" }}
          >
            Designed and built by Abhi
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
